/**
 * Single source of truth for the school grade option lists used by the
 * Grundschule and Gymnasium class selects across the write, edit, cards and
 * session-setup views.
 */
export let SCHOOL_GRADES = {
    grundschule: [
        { value: '1', label: '1. Klasse' },
        { value: '2', label: '2. Klasse' },
        { value: '3', label: '3. Klasse' },
        { value: '4', label: '4. Klasse' },
    ],
    gymnasium: [
        { value: '5', label: '5. Klasse' },
        { value: '6', label: '6. Klasse' },
        { value: '7', label: '7. Klasse' },
        { value: '8', label: '8. Klasse' },
        { value: '9', label: '9. Klasse' },
        { value: '10', label: '10. Klasse' },
        { value: '11', label: '11. Klasse' },
        { value: '12', label: '12. Klasse' },
        { value: '13', label: '13. Klasse' },
    ],
};

/**
 * Appends the grade options for the given kind ("grundschule" or "gymnasium")
 * to the given <select> element. The blank placeholder option already present
 * in the element is preserved.
 */
export function populateSchoolGradeSelect(selectEl, kind) {
    for (let grade of SCHOOL_GRADES[kind]) {
        let option = document.createElement('option');
        option.value = grade.value;
        option.textContent = grade.label;
        selectEl.appendChild(option);
    }
}
